import React from "react"
import styled from "styled-components"
import {
  Card,
  SectionTitle,
  CardV2,
  Badge,
  StatusText,
  StatusDiv,
  StatusMessage,
  BadgeText,
} from "../commonStyles"

const ComponentWrap = styled.div``

const Draft = () => (
  <ComponentWrap>
    <CardV2
      cardWidth="800px"
    >
      <StatusText>
        Status of the ICA
      </StatusText>
      <StatusDiv>
        <Badge
          bgColor="#E89208"
        >
          <img src="https://s3.amazonaws.com/cdn.agentdesks.com/images/ISA_ASSETS/Soul_ICA_Danger.png" alt="soul_asset" />
          <BadgeText>Draft</BadgeText>
        </Badge>
        <StatusMessage>
          Documents are ready to be reviewed.
        </StatusMessage>
      </StatusDiv>
    </CardV2>
  </ComponentWrap>
)

export default Draft
